import { useQuery } from '@tanstack/react-query';

import { getAgency } from '~/services/AgentHub/AgentService';

export const agencyQueryKeys = {
  all: ['agency'] as const,
  details: () => [...agencyQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...agencyQueryKeys.details(), id] as const,
};

interface UseGetAgencyOptions {
  enabled?: boolean;
}

export function useGetAgency(id: string, options: UseGetAgencyOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: agencyQueryKeys.detail(id),
    queryFn: async () => {
      return await getAgency(id);
    },
    enabled: enabled && !!id,
  });
}
